/**
 * @generated SignedSource<<ed027ec8aa5cd5f8b8368c2ef6a0752e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type BuildStatsBarFragment$data = {
  readonly finishDate: string | null | undefined;
  readonly queuedDate: string | null | undefined;
  readonly rawId: number | null | undefined;
  readonly runningInfo: {
    readonly elapsedSeconds: number | null | undefined;
  } | null | undefined;
  readonly startDate: string | null | undefined;
  readonly state: BuildState | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useRunningBuildUpdaterRelayFragment">;
  readonly " $fragmentType": "BuildStatsBarFragment";
};
export type BuildStatsBarFragment$key = {
  readonly " $data"?: BuildStatsBarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuildStatsBarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuildStatsBarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "queuedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgressInfo",
      "kind": "LinkedField",
      "name": "runningInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "elapsedSeconds",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRunningBuildUpdaterRelayFragment"
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "4d75c134b6c4b05dd3671f81a2673a67";

export default node;
